import React from 'react'
import irelandApi from "../irelandApi";
import qs from "qs";
import {destandard} from "../utils/commonFunctions";
import {history} from "../store";
import {toast} from "react-toastify";
import ToastMessage from '../components/common/toast-message'
import {actions} from "react-redux-form";

export const getUpsellPopups = (product) => (dispatch) => {
  dispatch({
    type: "GET_UPSELL_POPUP_LIST_PENDING",
    payLoad: []
  });
  let q = {
    product_id: product
  };

  return irelandApi.get(`/api/admin/upsell_popups?${qs.stringify({q: q}, {encodeValuesOnly: true})}`)
    .then((response) => {
      dispatch({type: "GET_UPSELL_POPUP_LIST_FULFILLED", payLoad: response.data});
    })
    .catch((error) => {
      dispatch({type: 'GET_UPSELL_POPUP_LIST_REJECTED', payLoad: error.data})
    })
};

export const getUpsellPopup = (id) => (dispatch) => {
  dispatch({type: "GET_UPSELL_POPUP_PENDING"});
  return irelandApi.get(`/api/admin/upsell_popups/${id}`)
    .then((response) => {
      const data = destandard({
        //image: response.data.data.attributes.links.image,
        ...response.data.data.attributes
      });
      dispatch({type: "GET_UPSELL_POPUP_FULFILLED", payLoad: data});

      return Promise.resolve(data);
    })
    .catch((error) => {
      toast.warn(<ToastMessage iconStyle="warning"
                               message={`Unable to get upsell popup.`}/>, {autoClose: 2000});
      dispatch({type: 'GET_UPSELL_POPUP_REJECTED', payLoad: "error"})
    })
};

export const deleteUpsellPopup = (id) => (dispatch) => {
  dispatch({type: "DELETE_UPSELL_POPUP_PENDING"});
  return irelandApi.delete(`/api/admin/upsell_popups/${id}`)
    .then((response) => {
      toast.success(<ToastMessage iconStyle="success" message="Upsell popup has been deleted successfully"/>);
      dispatch({type: "DELETE_UPSELL_POPUP_FULFILLED", payLoad: id});
      dispatch(getUpsellPopups());
    })
    .catch((error) => {
      const data = {
        ...error.response.data.errors
      };
      let message = "An error occured during delete upsell popup";
      if (data.has_items) {
        message = data.has_items;
      }
      toast.error(<ToastMessage iconStyle="error" message={message}/>);
      dispatch({type: 'DELETE_UPSELL_POPUP_REJECTED', payLoad: error.data});

      return Promise.reject(data);
    })
};

export const saveUpsellPopup = (payLoad) => dispatch => {
  dispatch({type: "SAVE_UPSELL_POPUP_PENDING"});
  let formData = new FormData();
  payLoad = removeNullFields(payLoad);

  payLoad["product_ids"] = payLoad["product_ids"].map(curr => {
    return curr.value;
  });

  Object.keys(payLoad).forEach(key => {
    if (`${key}` == 'product_ids') {
      payLoad[key].forEach(value => {
        formData.append(`upsell_popup[product_ids][]`, value)
      });
    } else {
      formData.append(`upsell_popup[${key}]`, payLoad[key])
    }
  });

  return irelandApi.post(`/api/admin/upsell_popups`, formData)
    .then((response) => {
      toast.success(<ToastMessage iconStyle="success" message="Upsell popup has been saved successfully"/>);
      history.push('/admin/upsell_popups');
    })
    .catch((error) => {
      const errorData = error.response.data.errors;
      let toastMessage = "An error occurred during save upsell popup";
      if (error.response.data.errors) {
        const errors = error.response.data.errors;
        if (errors.not_unique_error) {
          toastMessage = errors.not_unique_error;
        }
      }
      toast.error(<ToastMessage iconStyle="error" message={toastMessage}/>);
      dispatch({type: 'SAVE_UPSELL_POPUP_REJECTED', payLoad: errorData});
    })
};

export const updateUpsellPopup = (id, payLoad) => dispatch => {
  dispatch({type: "SAVE_UPSELL_POPUP_PENDING"});

  let formData = new FormData();
  payLoad = removeNullFields(payLoad);

  if (payLoad["product_ids"]) {
    payLoad["product_ids"] = payLoad["product_ids"].map(curr => {
      return curr.value;
    });
  }

  Object.keys(payLoad).forEach(key => {
    if (`${key}` == 'product_ids') {
      if (payLoad[key].length === 0) {
        formData.append(`upsell_popup[product_ids][]`, "")
      } else {
        payLoad[key].forEach(value => {
          formData.append(`upsell_popup[product_ids][]`, value)
        });
      }
    } else {
      formData.append(`upsell_popup[${key}]`, payLoad[key])
    }
  });

  return irelandApi.patch(`/api/admin/upsell_popups/${id}`, formData)
    .then((response) => {
      toast.success(<ToastMessage iconStyle="success" message="Upsell popup has been saved successfully"/>);
      history.push('/admin/upsell_popups');
    })
    .catch((error) => {
      const errorData = error.response.data.errors;
      let toastMessage = "An error occurred during save upsell popup";
      if (error.response.data.errors) {
        const errors = error.response.data.errors;
        if (errors.not_unique_error) {
          toastMessage = errors.not_unique_error;
        }
      }
      toast.error(<ToastMessage iconStyle="error" message={toastMessage}/>);
      dispatch({type: 'SAVE_UPSELL_POPUP_REJECTED', payLoad: errorData});
    })
};

const removeNullFields = (data) => {
  const copy = {...data};
  return copy;
};



// WEBPACK FOOTER //
// ./src/actions/upsell_popups.js